import script from "./broadcast.vue?vue&type=script&setup=true&lang=js"
export * from "./broadcast.vue?vue&type=script&setup=true&lang=js"

import "./broadcast.vue?vue&type=style&index=0&id=7949fbbc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7949fbbc"]])

export default __exports__